import React from 'react';

import { Radio } from 'antd';
import './SelectableRadioPanel.css';

export default class SelectableRadioPanel extends React.Component {

  render() {
    return (
      <div className={"selectable-radio-panel " + (this.props.selected ? "selectable-radio-panel-selected" : "")}>
        <Radio className="selectable-radio-panel-radio" value={this.props.radioKey} disabled={this.props.disabled ? this.props.disabled : false}>
          <div className="selectable-radio-panel-inner">
            {this.props.render()}
          </div>
        </Radio>
      </div>
    )
  }
}
